export const CLIENT = {
  FETCH: "CLIENT.FETCH",
  FETCH_SUCCESS: "CLIENT.FETCH_SUCCESS",
  FETCH_ERROR: "CLIENT.FETCH_ERROR",
  LOADING: "CLIENT.LOADING",
  CLEAR: "CLIENT.CLEAR",
  SET_CLIENT: "CLIENT.SET_CLIENT"
};

export default CLIENT;
